var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrinter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 33,
    viewBox: "0 0 35 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.73333 27.1333H3.93333C3.42058 27.1333 2.92883 26.9296 2.56626 26.5671C2.20369 26.2045 2 25.7128 2 25.2V15.5333C2 14.5078 2.40738 13.5243 3.13252 12.7992C3.85766 12.074 4.84116 11.6667 5.86667 11.6667H29.0667C30.0922 11.6667 31.0757 12.074 31.8008 12.7992C32.526 13.5243 32.9333 14.5078 32.9333 15.5333V25.2C32.9333 25.7128 32.7296 26.2045 32.3671 26.5671C32.0045 26.9296 31.5128 27.1333 31 27.1333H25.2H9.73333ZM9.73333 2H25.2V11.6667H9.73333V2ZM9.73333 23.2667H25.2V31H9.73333V23.2667Z",
    stroke: "#FAFAFA",
    strokeWidth: 2.41387,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinter);
export default __webpack_public_path__ + "static/media/printer.f2e9945b970a46f086baa8f35bc6c727.svg";
export { ForwardRef as ReactComponent };